import { gql } from '@apollo/client';

export const CREATE_REQUEST = gql`
  mutation createRequest($requestCreateDto: RequestCreateDto!) {
    createRequest(requestCreateDto: $requestCreateDto) {
      id
      name
      email
      phone
      institutionName
      buyer
      seller
      createdDt
      modifiedDt
      modifiedBy
      isDeleted
    }
  }
`;
